import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Tooltip from 'root/module/tooltip';
import Router from 'root/router';
import Modals from 'root/modals';
import View from 'view/base';
import View_Feedback_Comment_Editor from 'view/feedback_comment_editor';

var Feedback_Viewer_Reply_Comment = View.extend({
    className: 'thread-reply-comment',

    is_expanded: false,
    is_child: false,

    pending_xhr: [],

    views: {
        reply_comments: {},
        comment_editor: {}
    },

    events: {
        'click .edit'                      : 'edit',
        'click .delete'                    : 'delete',
        'click .edit-submit'               : 'save',
        'click .edit-cancel'               : 'editCancel',
        'paste .comment'                   : 'paste',
        'click .read-more'                 : 'readMore',
        'click .attach'                    : 'selectFile',
        'click .attachment-delete'         : 'deleteAttachment',
        'click .reply-thread'              : 'onReplyThread',
        'click .reply-toggle'              : 'onToggleReplies',
        'mouseenter .region-msg-container' : 'onMouseEnter',
        'mouseleave .region-msg-container' : 'onMouseLeave'
    },

    dom_handlers: {
        onMouseEnter: function(e) {
            e.stopPropagation();

            if (this.$el.hasClass('editing')) {
                return;
            }

            this.$el.find('.actions:first').show();
        },

        onMouseLeave: function(e) {
            e.stopPropagation();
            this.$el.find('.actions:first').hide();
            Tooltip.removeAll();
        },

        edit: function(e) {
            e.stopPropagation();

            this.$el.addClass('editing');

            this.$el.find('.actions:first').hide();
            this.$el.find('.edit-actions:first').show();

            var comment = Util.nl2br(this.model.escape('comment'));
            comment = Util.parseComment(comment);

            this.$el.find('.comment:first').html(comment);
            this.$el.find('.comment:first').prop('contenteditable', true).focus();
        },

        editCancel: function(e) {
            e.stopPropagation();

            this.$el.removeClass('editing');

            this.$el.find('.actions:first').show();
            this.$el.find('.edit-actions:first').hide();

            this.renderMsg();
        },

        delete: function(e) {
            e.stopPropagation();
            Modals.deleteComment(this.model);
        },

        paste: function(e) {
            if (this.$el.find('.comment:first').prop('contenteditable') != 'true') {
                return;
            }

            e.preventDefault();

            try {
                var text = (e.originalEvent || e).clipboardData.getData('text/plain');
                document.execCommand('insertText', false, text);
            } catch(e) {
            }
        },

        save: function(e) {
            e.stopPropagation();

            if (this.$el.find('.comment:first').prop('contenteditable') != 'true') {
                return;
            }

            this.$el.removeClass('editing');

            this.$el.find('.actions:first').show();
            this.$el.find('.edit-actions:first').hide();

            var comment = this.$el.find('.comment:first').prop('contenteditable', false).html();

            var temp_element = $('<div>').html(comment);
            temp_element.find('.at-name').each(function() {
                var user_id = $(this).attr('userid');
                this.outerHTML = '@@:' + user_id + ':' + $(this).text() + '@@';
            });

            comment = temp_element.html();
            comment = Util.sanitizeContenteditable(comment);
            comment = comment.trim();

            if (!comment) {
                this.renderMsg();
                return;
            }

            if (comment === this.model.get('comment')) {
                return;
            }

            this.model.set({
                comment: comment,
                last_edit_time: Math.ceil((new Date()).getTime() / 1000)
            });

            Cache.app.request({
                action: 'feedback\\comment/edit',
                context: this,
                data: {id: this.model.id, comment: comment},
                success: function(response) {
                    UI.success('Comment updated');
                }
            });
        },

        selectFile: function(e) {
            e.stopPropagation();

            Util.uploadFile(10, function(error, file_name, file_type, file_content) {
                if (error) {
                    UI.error(error);
                    return;
                }

                this.model.set({
                    'attachment': file_name,
                    'attachment_uploading': true
                });

                Cache.app.request({
                    action: 'feedback\\comment/uploadAttachment',
                    context: this,
                    data: {
                        id                   : this.model.id,
                        attachment_data_uri  : file_content,
                        attachment_file_name : file_name
                    },
                    success: function(response) {
                        this.model.set({
                            'attachment': response,
                            'attachment_uploading': false
                        });
                    }
                });
            }.bind(this));
        },

        deleteAttachment: function(e) {
            e.stopPropagation();
            Modals.deleteFeedbackCommentAttachment(this.model.id);
        },

        readMore: function(e) {
            e.preventDefault();
            e.stopPropagation();

            this.is_expanded = true;

            var comment = Util.nl2br(this.model.escape('comment'));
            comment = Util.urlify(comment);
            comment = Util.parseComment(comment);

            this.$el.find('.comment:first').html(comment);
        },

        onReplyThread: function(e) {
            this.$el.find('.region-replies').show();
            this.$el.addClass('reply-open');
            this.$el.find('.reply-toggle').text(this.getReplyToggleText());

            // workaround the issue where focus is lost due to the ducument click
            setTimeout(() => {
                this.views.comment_editor.focus();
            });
        },

        onToggleReplies: function(e) {
            e.preventDefault();

            this.$el.find('.region-replies').toggle();
            this.$el.toggleClass('reply-open');
            this.$el.find('.reply-toggle').text(this.getReplyToggleText());
        }
    },

    event_handlers: {
        onCommentAdd: function(model) {
            if (model.get('reply_comment_id') !== this.model.id) {
                return;
            }

            if (this.views.reply_comments['_' + model.id] instanceof Feedback_Viewer_Reply_Comment) {
                this.views.reply_comments['_' + model.id].remove();
            }

            this.views.reply_comments['_' + model.id] = new Feedback_Viewer_Reply_Comment({
                model    : model,
                inbox    : true,
                is_child : true
            });
            this.views.reply_comments['_' + model.id].render().$el.appendTo(this.$el.find('.region-reply-comments:first'));

            this.$el.find('.reply-toggle').text(this.getReplyToggleText());
        },

        onCommentRemove: function(model) {
            if (typeof this.views.reply_comments['_' + model.id] === 'undefined') {
                return;
            }

            this.views.reply_comments['_' + model.id].remove();
            delete this.views.reply_comments['_' + model.id];

            this.$el.find('.reply-toggle').text(this.getReplyToggleText());
        },

        onNewCommentSubmit: function(editor_data) {
            this.views.comment_editor.disable();

            var _doPost = () => {
                var xhr = Cache.app.request({
                    action: 'feedback\\Comment/add',
                    data: {
                        id                      : this.feedback.id,
                        reply_comment_id        : this.model.id,
                        is_public               : editor_data.is_public,
                        comment                 : editor_data.comment,
                        notify                  : editor_data.notify_list,
                        attachment_file_name    : editor_data.attachment.file_name,
                        attachment_file_content : editor_data.attachment.file_content
                    },
                    complete: () => {
                        var index = this.pending_xhr.indexOf(xhr);

                        if (index !== -1) {
                            this.pending_xhr.splice(index, 1);
                        }

                        if (this.views.comment_editor.enable) {
                            this.views.comment_editor.enable();
                        }
                    },
                    success: (data) => {
                        this.views.comment_editor.clearMessage();

                        Cache.feedback_comment.add(data);
                        UI.success('Comment added');
                    }
                });

                this.pending_xhr.push(xhr);
            };

            if (Cache.real_user_id) {
                _doPost();
            } else {
                var anon_user = Cache.getGuestUser();

                if (anon_user.email && anon_user.name) {
                    _doPost();
                } else {
                    Modals.viewerGuest(_doPost);
                }
            }
        }
    },

    initialize: function(options) {
        this.views = {
            reply_comments: {},
            comment_editor: {}
        };

        this.is_child   = !!options.is_child;
        this.inbox_view = !!options.inbox;
        this.feedback   = options.feedback;
        this.is_viewer  = options.is_viewer;

        this.desc_max_char = this.inbox_view ? 600 : 300;

        Cache.feedback_comment.where({reply_comment_id: this.model.id}).forEach((model) => {
            this.views.reply_comments['_' + model.id] = new Feedback_Viewer_Reply_Comment({
                model    : model,
                inbox    : true,
                is_child : true
            });
        });

        this.listenTo(this.model,    'change:comment',    this.renderMsg);
        this.listenTo(this.model,    'change:attachment', this.renderAttachment);

        if (!this.is_child) {
            this.views.comment_editor = new View_Feedback_Comment_Editor({
                model      : this.model,
                feedback   : this.feedback,
                inbox_view : this.inbox_view,
                is_viewer  : this.is_viewer
            });

            this.listenTo(Cache.feedback_comment, 'add',    this.event_handlers.onCommentAdd.bind(this));
            this.listenTo(Cache.feedback_comment, 'remove', this.event_handlers.onCommentRemove.bind(this));

            this.views.comment_editor.on('submit', this.event_handlers.onNewCommentSubmit.bind(this));
        }

        this.on('remove', () => {
            if (this.pending_xhr.length) {
                this.pending_xhr.forEach((xhr) => {
                    xhr.abort();
                });

                this.pending_xhr = [];
            }
        });
    },

    renderReactions: function() {
        var reactions = this.model.get('reaction');

        if (reactions) {
            try {
                reactions = JSON.parse(reactions);
            } catch(e) {
            }

            var html = '';

            reactions.forEach(function(reaction) {
                html += '<span class="reaction">' +
                            '<span class="emoji">' + String.fromCodePoint(reaction.emoji) + '</span>' +
                            '<span class="count">' + reaction.count + '</span>' +
                        '</span>';
            });

            this.$el.find('.region-reactions:first').html(html);
        } else {
            this.$el.find('.region-reactions:first').html('');
        }
    },

    renderMsg: function() {
        var content = '';
        content += '<div class="comment">';

        var comment     = this.model.get('comment');
        var do_ellipsis = !this.is_expanded && this.model.get('comment').length > this.desc_max_char;
        var char_stop   = this.desc_max_char;

        if (do_ellipsis) {
            var matches = comment.match(/@@:(-?[0-9]+):(@?[^@]+)@@/g);

            if (matches) {
                matches.forEach(function(match) {
                    var start = comment.indexOf(match);
                    var end   = start + match.length;

                    if (end === comment.length) {
                        // @name is the last word of the comment
                        do_ellipsis = false;
                    } else if (start < this.desc_max_char && end >= this.desc_max_char) {
                        // stop after the @name
                        char_stop = end;
                    }
                }.bind(this));
            }
        }

        if (do_ellipsis) {
            comment = Util.trim(comment, char_stop, '');
        }

        comment = Util.htmlEntities(comment);
        comment = Util.nl2br(comment);
        comment = Util.urlify(comment);
        comment = Util.parseComment(comment);
        content += comment;

        if (do_ellipsis) {
            content += ' <span style="white-space:nowrap;">... <a href="#" class="read-more primary font-weight-medium">See more</a></span>';
        }

        content += '</div>';

        if (this.model.get('last_edit_time')) {
            content +=
            '<div class="edited">' +
                '<span class="tooltip" data-title="' + Util.moment(this.model.get('last_edit_time')) + '">(edited)</span>' +
            '</div>';
        }

        this.$el.find('.region-msg:first').html(content);
    },

    renderAttachment: function() {
        var content = '';

        if (this.model.get('attachment')) {
            content += '<div class="attachment-container">';
            content += '<div class="attachment">';

            if (this.model.get('attachment_uploading')) {
                content += '<i class="far fa-fw fa-spinner fa-spin"></i> <span>' + Util.htmlEntities(Util.baseName(this.model.get('attachment'))) + '</span>';
            } else {
                content += Util.getFileIcon(this.model.get('attachment'), false) + '<a href="' + Util.safeUrl(this.model.get('attachment')) + '" target="_blank">' + Util.htmlEntities(Util.baseName(this.model.get('attachment'))) + '</a>';

                if (Cache.real_user_id && (this.model.get('user_id') === Cache.real_user_id || Cache.app.isAdmin())) {
                    content += '<button type="button" class="attachment-delete tooltip" data-title="Remove attachment"><i class="fa-solid fa-trash"></i></button>';
                }
            }

            content += '</div>';

            if (!this.model.get('attachment_uploading')) {
                content += Util.isImage(this.model.get('attachment')) ? '<a class="attachment-preview" href="' + this.model.get('attachment') + '" target="_blank"><img src="' + this.model.get('attachment') + '"></a>' : '';
                content += Util.isVideo(this.model.get('attachment')) ? '<a class="attachment-preview  attachment-preview-video" href="' + this.model.get('attachment') + '" target="_blank"><video src="' + this.model.get('attachment') + '" muted></video></a>' : '';
            }

            content += '</div>';
        }

        this.$el.find('.region-attachment:first').html(content);
    },

    renderReplies: function() {
        if (this.is_child) {
            return;
        }

        var container = this.$el.find('.region-reply-comments:first');

        _.each(this.views.reply_comments, function(view) {
            view.render().$el.appendTo(container);
        });
    },

    getReplyToggleText() {
        if (_.size(this.views.reply_comments) === 0) {
            return '';
        } else {
            if (this.$el.hasClass('reply-open')) {
                return 'Hide ' + _.size(this.views.reply_comments) + ' ' + (_.size(this.views.reply_comments) === 1 ? 'reply' : 'replies');
            } else {
                return 'Show ' + _.size(this.views.reply_comments) + ' ' + (_.size(this.views.reply_comments) === 1 ? 'reply' : 'replies');
            }
        }
    },

    onRender: function() {
        if (!this.is_child) {
            if (Router.getQueryString('c') == this.model.id) {
                // use setTimeout to delay this to the bottom of the render tree
                // otherwise jquery.toggle() breaks because the view hasn't been mounted to the document yet
                setTimeout(() => {
                    this.$el.find('.show-replies > a').click();
                    this.views.comment_editor.show();
                    this.views.comment_editor.focus();
                }, 0);
            }
        }
    },

    render: function() {
        var can_edit = Cache.real_user_id && (Cache.real_user_id === this.model.get('user_id') || Cache.app.isAdmin());

        var content =
        '<div class="reply-title">' +
        '<div class="user-img-24" style="background-image:url(\'' + this.model.getAvatar(24) + '\');"></div>' +
            '<div class="name tooltip" data-title="' + this.model.getDisplayName(true, false, true) + '">' + this.model.getDisplayName(false, true, true) + '</div>' +
            '<div class="time">' +
                ('<span class="tooltip" data-title="' + Util.moment(this.model.get('time'), 'DD MMM YYYY hh:mm a') + '">' + Util.moment(this.model.get('time')) + '</span>' || '-') +
                (this.model.get('source') === 'email_reply' ? ' (via email reply)' : '') +
            '</div>' +
            (Cache.real_user_id && !Cache.app.isClient() && !this.model.get('is_public') ?
            '<i class="comment-type-icon text-info fa-solid fa-lock tooltip" data-title="Team only"></i>' : '') +
        '</div>' +

        '<div class="reply-body' + (this.is_child ? ' reply-body-child' : '') + '">' +

            '<div class="region-msg-container">' +
                '<div class="region-msg"></div>' +

                '<div class="actions">' +
                    (!this.is_child && (this.feedback.get('allow_public_comment') || Cache.real_user_id) ?
                    '<button type="button" class="reply-thread"><i class="fa-solid fa-reply tooltip" data-title="Reply"></i></button>' : '') +
                    (can_edit ?
                    '<button type="button" class="edit"><i class="fa-solid fa-pen tooltip" data-title="Edit"></i></button>' +
                    '<button type="button" class="attach tooltip" data-title="Attach a file"' + (this.model.get('attachment') ? ' disabled' : '') + '><i class="fa-solid fa-paperclip"></i></button>' +
                    '<button type="button" class="delete"><i class="fa-solid fa-trash tooltip" data-title="Delete"></i></button>' : '') +
                '</div>' +

                (can_edit ?
                '<div class="edit-actions">' +
                    '<button class="edit-cancel text tiny">Cancel</button>' +
                    '<button class="edit-submit primary tiny">Save</button>' +
                '</div>' : '') +
            '</div>' +

            '<div class="region-reactions"></div>' +
            '<div class="region-attachment"></div>' +

            (!this.is_child && (this.feedback.get('allow_public_comment') || Cache.real_user_id) ?
            '<div class="show-replies">' +
                '<a href="#" class="reply-toggle">' + this.getReplyToggleText() + '</a>' +

                '<div class="region-replies">' +
                    '<div class="region-reply-comments"></div>' +
                    '<div class="region-new-reply">' +
                        (Cache.real_user_id ?
                        '<img class="user-24 user-current" src="' + Util.htmlEntities(Cache.getRealUser().getAvatar(24)) + '">' :
                        '<img class="user-24 user-current" src="' + Util.gravatar(Cache.getGuestUser().email, 24, Cache.getGuestUser().name) + '">') +
                    '</div>' +
                '</div>' +
            '</div>' : '') +

        '</div>';

        this.$el.html(content);

        this.renderMsg();
        this.renderReactions();
        this.renderAttachment();
        this.renderReplies();

        if (!this.is_child) {
            this.views.comment_editor.render().$el.appendTo(this.$el.find('.region-new-reply'));
        }

        this.$el.toggleClass('thread-reply-comment-internal', !this.model.get('is_public'));
        this.$el.toggleClass('thread-reply-comment-child', this.is_child);

        if (!this.is_rendered) {
            this.onRender();
            this.is_rendered = true;
        }

        return this;
    }
});

export default Feedback_Viewer_Reply_Comment;